import { z } from "zod";

export const supportFormSchema = z.object({
  email: z.string().email("Inserisci un indirizzo email valido"),
  message: z
    .string()
    .min(10, "Il messaggio deve contenere almeno 10 caratteri")
    .max(500, "Il messaggio non può superare 500 caratteri"),
});

export type SupportFormSchema = z.infer<typeof supportFormSchema>;
